import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import "./SearchLocation.css";
import { useDispatch, useSelector } from "react-redux";
import { stepsActions } from "../../../../../store/steps-slice";
import { useEffect } from "react";

const SearchLocation = () => {
  const dispatch = useDispatch();
  const location = useSelector((state) => state.steps.location);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });
  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleInput = (e) => {
    // Update the keyword of the input element
    setValue(e.target.value);
  };

  const handleSelect =
    ({ description, ...rest }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"

      setValue(description, false);
      dispatch(stepsActions.handleSetAutoComplete({ ...rest, description }));
      dispatch(stepsActions.handleSetGeocoder(null));
      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        dispatch(stepsActions.setCoords({ lat, lng }));
        sessionStorage.setItem("lat", lat);
        sessionStorage.setItem("lng", lng);
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li key={place_id} onClick={handleSelect(suggestion)} className="location-suggestion">
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  useEffect(() => {
    setValue(location?.location, false);
  }, [location]);

  useEffect(() => {
    if (value && value.length > 1) {
      dispatch(stepsActions.handleSearchLocationInput(true));
    } else {
      dispatch(stepsActions.handleSearchLocationInput(false));
    }
  }, [value]);

  return (
    <div ref={ref} className="searchLocation">
      <input value={value} onChange={handleInput} disabled={!ready} placeholder="Select a place name, address or coordinates" className="locationSearchInput" />
      {/* We can use the "status" to decide whether we should display the dropdown or not */}
      {status === "OK" && <ul className="searchLists">{renderSuggestions()}</ul>}
    </div>
  );
};

export default SearchLocation;
